import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { QuestionViewModel } from 'src/app/shared/models/questionview.model';

@Component({
  selector: 'app-rating-view',
  templateUrl: './rating-view.component.html',
  styleUrls: ['./rating-view.component.scss']
,  standalone: false
})
export class RatingViewComponent implements OnInit {
  @Input() ratingConfig:RatingResponse;
  @Output() updateConfig = new EventEmitter<RatingResponse>();
  @Input() isEditing = false;
  @Input() showName?: boolean=true;
  @Input() IsReadOnly?:boolean=false;
  getNumbers: number = 10;

  @Input() question: QuestionViewModel;
  @Input() questionIndex: number;
  @Input() totalQuestion: number;
  minLength: number = 0;
  maxLength: number = 999;
  errormgvisible: boolean = false;
  validationerrormessage: string[] = [];
  isConditionIsTrue: boolean;
  //validationPattern: string = "[0-9]{1,999}"
  //validationPattern: string = "^[a-zA-Z0-9!@#$&%()\\-`.+,/\"]*$"
  validationPattern: string = "[A-Z0-9!@#$&%()\\-`.+,/\"^a-z]{1,999}"
  checkallvalidations: string = "";
  numberPattern: string = "0-9";
  alphabetsPattern: string = "A-Za-z";
  specialCharactersPattern: string = "!@#$&()\\-`.+,/\"*$%_^";
  isNumberValidation: boolean = false;
  isCharactersValidation: boolean = false;
  isSpecialCharactersValidation: boolean = false;
  excludeCharacters: string;
  isExcludeCharactersValidation: boolean = false;
  controlColor: string;
  @Input() foregroundcolor: string;
  @Input() backgroundcolor: string;
  @Input() theme: string;
  @Input() controlBGColor: string;
  @Input() controlBorder: string;
  @Input() TextColor: string;
  @Input() tableBorder: string;


ngDoCheck()
{
  this.errormgvisible=false;
  this.validationerrormessage=[];
  if(this.question.errorMessage)
  {
  this.CheckValidations();
  }
}
  ngOnInit() {

    if (this.question.isQuestionRequired == "Y") {
      this.isConditionIsTrue = true;
    }
    else {
      this.isConditionIsTrue = false;
    }

    this.question.validationDetails.forEach((obj, index) => {
      //to add number pattern only once
      if (this.isNumberValidation === false) {
        if (obj.isNumericAllowed === true) {
          this.isNumberValidation = true;
          this.checkallvalidations += this.numberPattern;
        }
      }
      if (this.isCharactersValidation === false) {
        if (obj.isCharacterAllowed === true) {
          this.isCharactersValidation = true;
          this.checkallvalidations += this.alphabetsPattern;
        }
      }
      if (this.isSpecialCharactersValidation === false) {
        if (obj.isSpecialCharacterAllowed === true) {
          this.isSpecialCharactersValidation = true;
          this.checkallvalidations += this.specialCharactersPattern;
        }
      }
      if (this.isExcludeCharactersValidation === false) {
        if (obj.excludeCharacters != null && obj.excludeCharacters != "") {
          this.isExcludeCharactersValidation = true;
          this.excludeCharacters = obj.excludeCharacters;
        }
      }
      this.validationerrormessage.push(obj.errorMessage);
      //check min length and max length
      if (obj.minRange != null && obj.minRange >= 0 && obj.maxRange != null && obj.maxRange > 0) {
        this.minLength = obj.minRange;
        this.maxLength = obj.maxRange;

      }
      if (obj.regularExpression != null && obj.regularExpression != "") {
        this.validationPattern = obj.regularExpression + "{1,999}";
      }
    });
    if (this.checkallvalidations != "" && this.checkallvalidations != null) {
      this.validationPattern = "[" + this.checkallvalidations + "]{1,999}"
    }

    if(this.question.responseText)
    {
        this.ratingConfig.rating=Number(this.question.responseText);
    }
    this.CheckValidations();
    this.errormgvisible=false;
    this.validationerrormessage=[];
  }

  emitUpdatedData() {
    this.updateConfig.emit(this.ratingConfig);
  }

  OnMouseOver(event,question, option, index): void {
    event.target.style.backgroundColor = this.foregroundcolor;
    event.target.style.color=this.TextColor;
  }
  OnMouseOut(event,question, option, index): void {
    if (!question.options[index].selected) {
    event.target.style.backgroundColor = this.controlBGColor;
    event.target.style.color="";
    }
  }

  updateValue(val) {
    this.ratingConfig.rating = val;
    this.updateConfig.emit(this.ratingConfig);
    this.question["responseText"] = val;
    this.CheckValidations();
  }
  CheckValidations()
  {
    if (this.question.isQuestionRequired == "Y") {
      if (this.question["responseText"] == null || this.question["responseText"] == "") {
        this.question["IsValid"] = false;
        this.errormgvisible=true;
        this.validationerrormessage.push("Input is mandatory");
      }
      else {
        this.question["IsValid"] = true;
      }
    }
    else {
      this.question["IsValid"] = true;
    }
  }
}

export class RatingResponse {
  initialText?: string;
  finalText?: string;
  rating?: number;
}
